import ReactGA from 'react-ga4'

const GOOGLE_ANALYTICS_TAG = process.env.REACT_APP_GOOGLE_ANALYTICS_FOUR_TAG

export function initializeGA() {
  if (GOOGLE_ANALYTICS_TAG) {
    ReactGA.initialize(GOOGLE_ANALYTICS_TAG)
  }
}
